import React from "react";

import { GameRunnerProps, GameRunnerVersion } from "./types";
import { GameRunnerList, GameRunnerMap } from "./game_runner_list";

export const GameRunner = ({ title, src, version = '0.4' }: GameRunnerProps) => {
    const Runner = GameRunnerMap.get(GameRunnerList.indexOf(version) >= 0 ? version : '0.4')
    return <Runner title={title} src={src} />
}